import moment from 'moment';
import { API_DATETIME_FORMAT } from '../../constants/date-format';
import { FiltersFormValue, QueryData } from './query-data.payload';
import {
  NotificationCampaignTargetedActiveUsers,
  NotificationTemplate,
} from '../enums/notification.enums';
import { SubscriptionTier } from '../enums/subscription.enums';
import { Writer } from '../entities/writer.entity';
import { Exam } from '../entities/exam.entity';
import { ExamGroup } from '../entities/exam-group.entity';
import { Article } from '../entities/article.entity';
import { Course } from '../entities/course.entity';

export interface NotificationCampaignFormValue {
  templateName: NotificationTemplate;
  title: string;
  message: string;
  path: string;
  subscriptionTierTarget: SubscriptionTier[];
  targetedActiveUsers: NotificationCampaignTargetedActiveUsers;
  isMailSupported: boolean;
  isPushSupported: boolean;
  isWebsiteSupported: boolean;
  publishAt: Date;

  exam?: Exam;
  examGroup?: ExamGroup;
  article?: Article;
  course?: Course;
}

export class NotificationCampaignPayload {
  templateName: NotificationTemplate;
  title: string;
  message: string;
  path: string;
  subscriptionTierTarget: SubscriptionTier[];
  targetedActiveUsers: NotificationCampaignTargetedActiveUsers;
  isMailSupported: boolean;
  isPushSupported: boolean;
  isWebsiteSupported: boolean;
  publishAt: string;

  constructor(formValue: NotificationCampaignFormValue) {
    this.templateName = formValue.templateName;
    this.title = formValue.title;
    this.message = formValue.message;
    this.path = formValue.path;
    this.subscriptionTierTarget = formValue.subscriptionTierTarget;
    this.targetedActiveUsers = formValue.targetedActiveUsers;
    this.isMailSupported = formValue.isMailSupported;
    this.isPushSupported = formValue.isPushSupported;
    this.isWebsiteSupported = formValue.isWebsiteSupported;
    this.publishAt = moment(formValue.publishAt).format(API_DATETIME_FORMAT);

    if (formValue.templateName === NotificationTemplate.NEW_EXAM_ONLINE) {
      this.title = $localize`Nouvel examen en ligne`;
      this.message = $localize`Nouvel examen : ${formValue.exam.title}`;
      this.path = `/app/exams/examens/${formValue.exam.id}`;
    } else if (formValue.templateName === NotificationTemplate.NEW_CORRECTION_ONLINE) {
      (this.title = $localize`Nouvelle correction disponible`),
        (this.message = $localize`La correction est disponible pour l'examen ${formValue.exam.title}`);
      this.path = `/app/exams/examens/${formValue.exam.id}`;
    } else if (formValue.templateName === NotificationTemplate.NEW_RANKING_ONLINE) {
      (this.title = $localize`Nouveau classement`),
        (this.message = $localize`Les classements sont disponibles pour l'examen ${formValue.exam.title}"`);
      this.path = `/app/exams/examens/${formValue.exam.id}`;
    } else if (formValue.templateName === NotificationTemplate.NEW_EXAM_GROUP_RANKING_ONLINE) {
      (this.title = $localize`Nouveau classement`),
        (this.message = $localize`Le classement ${formValue.examGroup.title} est disponible`);
      this.path = `/app/multi-ranking/ranking/${formValue.examGroup.id}`;
    } else if (formValue.templateName === NotificationTemplate.NEW_ARTICLE_ONLINE) {
      (this.title = $localize`Un nouvel article a été mis en ligne`),
        (this.message = $localize`Un nouvel article a été mis en ligne : ${formValue.article.title}`);
      this.path = `/app/blog/${formValue.article.id}`;
    } else if (formValue.templateName === NotificationTemplate.NEW_ITEM_ONLINE) {
      (this.title = $localize`Nouveau cours en ligne`),
        (this.message = `${formValue.course.ecniNumber} : ${formValue.course.title}`);
      this.path = `/app/courses/course/${formValue.course.id}`;
    }
  }
}

export class UpdateNotificationCampaignPublishAtPayload {
  publishAt: string;

  constructor(publishAt: Date) {
    this.publishAt = moment(publishAt).format(API_DATETIME_FORMAT);
  }
}

export interface WNotificationCampaignsFiltersFormValue extends FiltersFormValue {
  templateName?: NotificationTemplate;
  title?: string;
  subscriptionTierTarget?: SubscriptionTier;
  targetedActiveUsers?: NotificationCampaignTargetedActiveUsers;
  isProcessed?: boolean;
  isWebsiteSupported?: boolean;
  isMailSupported?: boolean;
  isPushSupported?: boolean;
  author?: Writer;
}

export class WNotificationCampaignsQueryData extends QueryData {
  templateName?: NotificationTemplate;
  title?: string;
  subscriptionTierTarget?: SubscriptionTier;
  targetedActiveUsers?: NotificationCampaignTargetedActiveUsers;
  isProcessed?: boolean;
  isWebsiteSupported?: boolean;
  isMailSupported?: boolean;
  isPushSupported?: boolean;
  'author.id'?: string;

  constructor(filtersFormValue: WNotificationCampaignsFiltersFormValue, partial?: boolean) {
    super(filtersFormValue, partial);
    this.templateName = filtersFormValue.templateName;
    this.title = filtersFormValue.title;
    this.subscriptionTierTarget = filtersFormValue.subscriptionTierTarget;
    this.targetedActiveUsers = filtersFormValue.targetedActiveUsers;
    this.isProcessed = filtersFormValue.isProcessed;
    this.isWebsiteSupported = filtersFormValue.isWebsiteSupported;
    this.isMailSupported = filtersFormValue.isMailSupported;
    this.isPushSupported = filtersFormValue.isPushSupported;
    this['author.id'] = filtersFormValue.author?.id;
  }
}
